import { Injectable, inject, linkedSignal, signal } from '@angular/core';
import { CurrentUrlService } from '@cumlaude/shared-services';
import { ancestorUrls } from '../layout/hoofdnavigatie/navigatie-model';

/**
 * Welke groepen in de verticale hoofdnavigatie openstaan, en of de rail is ingeklapt.
 *
 * In-memory: overleeft navigeren binnen de app, niet een paginareload. Bij een deeplink/refresh op
 * een diepe pagina (bv. /doorstroom/idu/matrix) klapt de tak naar die pagina automatisch open,
 * zodat de actieve pagina nooit onzichtbaar onder een dichte hoofdpagina staat.
 */
@Injectable({
	providedIn: 'root',
})
export class NavigatieUitklapService {
	private readonly currentUrl = inject(CurrentUrlService);

	/**
	 * Urls van de opengeklapte groepen. Groeit bij navigatie automatisch mee met de ancestors van
	 * de nieuwe pagina, bovenop wat de gebruiker zelf al had opengeklapt.
	 */
	readonly open = linkedSignal<string | undefined, ReadonlySet<string>>({
		source: () => this.currentUrl.currentPath(),
		computation: (pad, vorige) => new Set([...(vorige?.value ?? []), ...ancestorUrls(pad)]),
	});

	readonly ingeklapt = signal(false);

	toggle(url: string) {
		const nieuw = new Set(this.open());
		if (nieuw.has(url)) nieuw.delete(url);
		else nieuw.add(url);
		this.open.set(nieuw);
	}

	allesDichtklappen() {
		this.open.set(new Set());
	}

	zetIngeklapt(waarde: boolean) {
		this.ingeklapt.set(waarde);
	}

	toggleIngeklapt() {
		this.ingeklapt.update((waarde) => !waarde);
	}
}
